import classNames from 'classnames';
import css from './InternalTestingBadge.module.scss';

/**
 * The muted "internal testing" tag on the publishing entry points (the
 * Schedule nav row, the Settings Publishing tab). One component so both
 * carry the same copy and look; it goes with `PUBLISHING_INTERNAL_ONLY`
 * (see `FIXME(publishing-internal-only)` in `stores/Debug.ts`). Placement
 * is the caller's, through `className`.
 */
export const InternalTestingBadge = ({ className }: { className?: string }) => (
  <span className={classNames(css.badge, className)}>Internal testing</span>
);
